export default __webpack_public_path__ + "static/media/information--litter-container--g1.08c4ff13.png";